import {
  AllegroReturnPolicyAvailabilityRange,
  AllegroReturnPolicyRestrictionCauseName,
} from '../../../../../api/allegro/returnpolicy/returnPolicyTypes';

const RESTRICTED_RANGE_CAUSES: AllegroReturnPolicyRestrictionCauseName[] = [
  AllegroReturnPolicyRestrictionCauseName.SEALED_MEDIA,
  AllegroReturnPolicyRestrictionCauseName.SEALED_ITEM_NO_RETURN_DUE_HEALTH_OR_HYGIENE,
  AllegroReturnPolicyRestrictionCauseName.INSEPARABLY_LINKED,
  AllegroReturnPolicyRestrictionCauseName.NOT_RECORDED_DIGITAL_CONTENT,
];

const DISABLED_RANGE_CAUSES: AllegroReturnPolicyRestrictionCauseName[] = [
  AllegroReturnPolicyRestrictionCauseName.CUSTOM_ITEM,
  AllegroReturnPolicyRestrictionCauseName.SHORT_SHELF_LIFE,
  AllegroReturnPolicyRestrictionCauseName.PRESS,
  AllegroReturnPolicyRestrictionCauseName.MEDICINAL_PRODUCT,
  AllegroReturnPolicyRestrictionCauseName.VALUE_DEPENDENT_ON_FINANCIAL_MARKET,
];

export function requiresPolicyDetails(
  range: AllegroReturnPolicyAvailabilityRange | null,
): boolean {
  return range === AllegroReturnPolicyAvailabilityRange.FULL
    || range === AllegroReturnPolicyAvailabilityRange.RESTRICTED;
}

export function requiresRestrictionCause(
  range: AllegroReturnPolicyAvailabilityRange | null,
): boolean {
  return range === AllegroReturnPolicyAvailabilityRange.RESTRICTED
    || range === AllegroReturnPolicyAvailabilityRange.DISABLED;
}

export function getRestrictionCauses(
  range: AllegroReturnPolicyAvailabilityRange | null,
): AllegroReturnPolicyRestrictionCauseName[] {
  if (range === AllegroReturnPolicyAvailabilityRange.RESTRICTED) {
    return RESTRICTED_RANGE_CAUSES;
  }

  if (range === AllegroReturnPolicyAvailabilityRange.DISABLED) {
    return DISABLED_RANGE_CAUSES;
  }

  return [];
}
